import { Grid, Typography } from 'gu-ui-kit'
import format from 'utils/dateFns/format'
import React from 'react'
import PropTypes from 'prop-types'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

export const DateCell = ({ created_at }) => {
  const breakpoints = useBreakpoint()

  return (
    <Grid
      gap={breakpoints.fbs ? 8 : 4}
      direction={breakpoints.fbs ? 'row' : 'column'}
    >
      <Typography variant={'Body-10'} color={'Label-Fifth'} component={'div'}>
        {format(Date.parse(created_at), 'dd.MM.yyyy')}
      </Typography>
      <Typography
        variant={'Body-10'}
        color={'Label-Secondary'}
        component={'div'}
      >
        {format(Date.parse(created_at), 'HH:mm')}
      </Typography>
    </Grid>
  )
}

DateCell.propTypes = {
  created_at: PropTypes.string,
}
